import { Controller } from "@hotwired/stimulus";

const backgroundColors = [
  "rgba(16, 185, 129, 0.3)",
  "rgba(64, 131, 207, 0.3)",
  "rgba(255, 99, 132, 0.3)",
  "rgba(255, 206, 86, 0.3)",
  "rgba(54, 162, 235, 0.3)",
  "rgba(75, 192, 192, 0.3)",
  "rgba(153, 102, 255, 0.3)",
  "rgba(255, 159, 64, 0.3)",
];

const borderColors = [
  "rgba(16, 185, 129, 1)",
  "rgba(64, 131, 207, 1)",
  "rgba(255, 99, 132, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(255, 159, 64, 1)",
];

export default class extends Controller {
  async connect() {
    this.connected = true;

    const [{ Chart }, { default: ChartDataLabels }] = await Promise.all([
      import("../application/lib/charts"),
      import("chartjs-plugin-datalabels"),
    ]);

    if (!this.connected || this.chart) return;

    this.chart = new Chart(this.element.getContext("2d"), {
      plugins: [ChartDataLabels],
      ...this.chartParams,
    });
  }

  disconnect() {
    this.connected = false;
    this.chart?.destroy();
    this.chart = null;
  }

  get chartParams() {
    const values = JSON.parse(this.element.dataset.values);
    const total = values.reduce((acc, value) => acc + value, 0);

    const data = {
      labels: JSON.parse(this.element.dataset.labels),
      datasets: [
        {
          data: values,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
        },
      ],
    };

    return {
      type: "doughnut",
      data,
      options: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 120,
            top: 20,
            bottom: 20,
            right: 120,
          },
        },
        plugins: {
          legend: {
            display: this.element.dataset.legend === "true",
          },
          datalabels: {
            formatter: (_, context) => {
              return context.chart.data.labels[context.dataIndex];
            },
            labels: {
              title: {
                display: "auto",
                anchor: "end",
                align: "end",
              },
              value: {
                display: false,
                formatter: (value) => {
                  return Math.round((value / total) * 100) + "%";
                },
              },
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                let label = context.dataset.label || "";

                if (label) {
                  label += ": ";
                }

                if (context.parsed !== null) {
                  label += Math.round((context.parsed / total) * 100) + "%";
                }

                return label;
              },
            },
          },
        },
      },
    };
  }
}
